import { defineTemplate } from 'src/utils';
import { macroAhorro1080x1920 } from './layouts/Ahorro-1080x1920';
import { BRANDS } from '../_shared/data/brands';
import { CATEGORY_OPTIONS } from '../_shared/data/category-options';
import { BRAND_LOGOS_MAX } from '../_shared/images/brand-logos';
import { PAYMENT_METHOD_TEXT_OPTIONS } from '../_shared/data/payment-method-options';
import { LEGALES_OPTIONS } from '../_shared/data/legales-options';
import { MACRO_MEDIA_BASE } from '../_shared/data/media';

const THUMB = `${MACRO_MEDIA_BASE}/templates/macro-ahorro/thumbnails/macro-ahorro.png`;

export const macroAhorro = defineTemplate({
  mode: 'wysiwyg',
  id: 'macro-ahorro',
  clientId: 'MACRO',
  handlerKey: 'MACRO',
  title: 'Ahorro',
  thumbnail: { url: THUMB, optimizedUrl: THUMB, aspectRatio: 'vertical' },
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'category',
      label: 'Categoría',
      type: 'select',
      required: true,
      defaultValue: 'GASTRONOMÍA',
      placeholder: 'Selecciona una categoría',
      options: CATEGORY_OPTIONS
    },
    {
      key: 'valid-days',
      label: 'Días de validez',
      type: 'input',
      placeholder: 'Ejemplo: Lunes a viernes',
      required: true,
      defaultValue: 'Lunes'
    },
    {
      key: 'discount-value',
      label: 'Texto del descuento',
      type: 'number',
      placeholder: 'Ejemplo: 20%',
      required: true,
      defaultValue: 20
    },
    {
      key: 'benefit-label',
      label: 'Beneficio',
      type: 'input',
      placeholder: 'de descuento, de 2x1, etc.',
      required: true,
      defaultValue: 'de ahorro'
    },
    {
      key: 'payment-method-text',
      label: 'Mensaje principal',
      type: 'input',
      placeholder: 'Con todas tus Tarjetas de Crédito Macro',
      required: true,
      defaultValue: 'Con todas tus Tarjetas de Crédito Macro',
      options: PAYMENT_METHOD_TEXT_OPTIONS
    },
    {
      key: 'payment-method-highlight-left',
      label: 'Pill izquierda',
      type: 'input',
      placeholder: 'Exclusivo con',
      required: true,
      defaultValue: 'Exclusivo con'
    },
    {
      key: 'payment-method-highlight-right',
      label: 'Pill derecha',
      type: 'input',
      placeholder: 'desde App',
      required: true,
      defaultValue: 'desde App'
    },
    {
      key: 'limit-text',
      label: 'Texto del tope',
      type: 'input',
      multiline: true,
      placeholder: 'Ejemplo: Hasta agotar stock',
      required: true,
      defaultValue: 'Tope $10.000 por cliente, por semana.'
    },
    {
      key: 'legales',
      label: 'Legales',
      type: 'input',
      placeholder: 'CARTERA CONSUMO',
      required: false,
      options: LEGALES_OPTIONS
    },
    {
      key: 'background-image',
      label: 'Imagen de fondo',
      type: 'image',
      required: false
    },
    {
      key: 'brand-logos',
      label: 'Logos de marcas',
      type: 'image-multi-select',
      required: false,
      defaultValue: [],
      maxSelections: BRAND_LOGOS_MAX,
      options: BRANDS.map(b => ({
        value: b.value,
        label: b.label,
        imageUrl: b.imageUrl
      }))
    }
  ],
  canvasBinding: {
    resolutions: [
      {
        id: '1080x1920',
        label: '1080×1920',
        canvasWidth: 1080,
        canvasHeight: 1920,
        type: 'image',
        layout: macroAhorro1080x1920
      }
    ],

    fieldBindings: [
      { kind: 'simple', fieldKey: 'category', pieceId: 'category', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'valid-days', pieceId: 'valid-days', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'discount-value', pieceId: 'discount-value', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'benefit-label', pieceId: 'benefit-label', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'payment-method-text', pieceId: 'payment-method-text', bindingType: 'text' },
      {
        kind: 'simple',
        fieldKey: 'payment-method-highlight-left',
        pieceId: 'payment-method-highlight-left',
        bindingType: 'text'
      },
      {
        kind: 'simple',
        fieldKey: 'payment-method-highlight-right',
        pieceId: 'payment-method-highlight-right',
        bindingType: 'text'
      },
      { kind: 'simple', fieldKey: 'limit-text', pieceId: 'limit-text', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'legales', pieceId: 'legales', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'background-image', pieceId: 'background-image', bindingType: 'image-replace' },
      { kind: 'simple', fieldKey: 'brand-logos', pieceId: 'brand-logos', bindingType: 'group-collection' }
    ]
  }
});
